var video_interactions_module = {};

import browser_module from './get-browser.js';
import video_global_vars_module from './variables.js';

var $browser = browser_module.get_browser();

video_interactions_module.pause_video = function (video, $playButton, $video_overlay) {

  // Pause the video
    var playPromise = video.pause();

    if ($browser.name != "IE") {
    
      if (playPromise !== undefined) {
        playPromise.then(function(_) {
          return video.pause();
        })
        .catch(function(error) {
        });
      }

    } else {
      video.pause();
    }

  // Update the button text to 'Play'
  $playButton.html("<i class='fa fa-play'></i>");
  $video_overlay.fadeIn();

}

video_interactions_module.play_video = function(video, $playButton, $video_overlay) {

    if ($browser.name != "IE") {

      var playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.then(function(_) {
          video.play();
        })
        .catch(function(error) {
          console.log(error);
        });
      }

      video_global_vars_module.user_paused = 0;

    } else {

      video.play();

    }

    // Update the button text to 'Pause'
    $playButton.html("<i class='fa fa-pause'></i>");
    $video_overlay.fadeOut();


}

video_interactions_module.restart_video = function(video) {

  if ($browser.name != "IE") {
  
  var playPromise = video.play();
  
  if (playPromise !== undefined) {
    playPromise.then(function(_) {
      video.pause();
    })
    .catch(function(error) {
      console.log(error);
    });
  }

  } else {
    
    video.pause();

  }

  video.currentTime = 0;

}

video_interactions_module.toggle_video_play_overlay =  function(video_id, $playButton) {

  var video_id = video_id,
    video_argument = '#' + video_id,        
    $video = $(video_argument),
    $video_object = $video.get(0),
    $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
    can_pause = $video.data('pause');

    console.log($playButton);

    video_interactions_module.play_video($video_object,$playButton, $video_overlay);

}

video_interactions_module.toggle_play_pause =  function(video_id, $playButton) {

  var video_id = video_id,
      video_argument = '#' + video_id,
      $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
      $video = $(video_argument),
      $video_object = $video.get(0);

  if ($video.hasClass(video_id)) {
      
      if ($video_object.paused == true) {

        video_interactions_module.play_video($video_object, $playButton, $video_overlay );
        video_global_vars_module.user_paused = 0;

      } else {
      
        video_interactions_module.pause_video( $video_object, $playButton, $video_overlay);
        video_global_vars_module.user_paused = 1;

    }
  }

}

video_interactions_module.open_full_screen =  function(video_id) {

  var video_argument = '#' + video_id,
      $video = $(video_argument),
      $video_object = $video.get(0);

  if ($video.hasClass(video_id)) {
    if ($video_object.requestFullscreen) {
        $video_object.requestFullscreen();
    } else if ($video_object.mozRequestFullScreen) {
        $video_object.mozRequestFullScreen(); // Firefox
    } else if ($video_object.webkitRequestFullscreen) {
        $video_object.webkitRequestFullscreen(); // Chrome and Safari
    } else if ($video_object.msRequestFullscreen) {
        $video_object.msRequestFullscreen();
      }
    }

}

video_interactions_module.seekbar_change =  function(video_id) {

  var video_argument = '#' + video_id,
        $video = $(video_argument),
        $video_object = $video.get(0),
        seekbar_arg = '.js-seek-bar[data-video-id="' + video_id + '"]',
        $video_overlay = $('.js-play-overlay[data-video-id="' + video_id +'"]'),
        $seekBar = $(seekbar_arg);

    if ($video.hasClass(video_id)) {

      // Calculate the new time
      var time = $video_object.duration * ($seekBar.val() / 100);

      // Update the video time
      $video_object.currentTime = time;

      video_interactions_module.play_video($video_object, $('.js-play-pause'), $video_overlay );      

    }
}


video_interactions_module.seekbar_timeupdate =  function(video_id) {

    var video_argument = '#' + video_id,
        $video = $(video_argument),
        $video_object = $video.get(0),
        seekbar_arg = '.js-seek-bar[data-video-id="' + video_id + '"]',
        $seekBar = $(seekbar_arg);

    if ($video.hasClass(video_id)) {

        // Calculate the slider value
        var value = (100 / $video_object.duration) * $video_object.currentTime; 

        if (value) {

          $seekBar.val( value );

        } 

    }
}

video_interactions_module.volume_change =  function(video_id) {
  
  var video_argument = '#' + video_id,
      $video = $(video_argument),
      $video_object = $video.get(0),
      volume_bar_arg = '.js-volume-bar[data-video-id="' + video_id + '"]',
      $volumeBar = $(volume_bar_arg);

  if ($video.hasClass(video_id)) {

    $video_object.volume = $volumeBar.val();

  }

}

video_interactions_module.reset_video = function(video_id) {
  var video_argument = '#' + video_id,
      $video = $(video_argument),
      $video_object = $video.get(0),
      seekbar_arg = '.js-seek-bar[data-video-id="' + video_id + '"]',
      $seekBar = $(seekbar_arg),
      video_container_arg = '.js-video-container[data-video-id="' + video_id + '"]',
      $video_container = $(video_container_arg);

  if (!$video_container.hasClass('js-video-player--autoplay')) {

    $('.js-video-container[data-video-id="' + video_id +'"] .js-play-overlay').fadeIn();

     $video_object.currentTime = 0;
     $seekBar.val( 0 );

  }

}

export default video_interactions_module